import axios from '@/plugins/axios'

export function login(data) {
	return axios({
		url: 'jd/user/login',
		method: 'post',
		data:data
	})
}